// @ts-nocheck
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { boxStyles } from "@store/Themes/common/mixins/box";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const signInWrapperStyles = () => {
    return css`
        position: relative;
        ${boxStyles()}
    `;
};

export const bottomBlueBorder = () => {
    return css`
        &::after {
            content: "";
            position: absolute;
            right: ${pxToRem(-3)};
            bottom: 0;
            left: ${pxToRem(-3)};
            height: ${pxToRem(10)};
            background-color: ${getColor("primary")};
        }
    `;
};

export const submitSignInButtonStyles = () => {
    return css`
        ${({ theme }) => theme.button?.primary?.css}
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: auto;
                        min-width: ${pxToRem(210)};
                    `,
                ],
                mediaOptions.min,
            )}
    `;
};
